export default __webpack_public_path__ + "static/media/worker2.d871ce7c.jpg";